/* LSL · collections : le bouton « simulateur » de la carte guide ouvre une fenêtre sur la page, au lieu d'envoyer vers l'accueil.
   Le contenu (sabres, sons) n'est chargé qu'au premier clic. Sans JavaScript, le lien d'origine reste utilisable. */
(() => {
  'use strict';
  const root = document.querySelector('[data-c-root]');
  if (!root) return;
  let dlg = null, loaded = false;
  const coreSrc = document.documentElement.dataset.mqCore || '';

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'c-simdlg';
    dlg.setAttribute('aria-labelledby', 'c-simpop-title');
    dlg.innerHTML = '<div class="c-simdlg__slot"><p class="c-simdlg__wait">Chargement du simulateur…</p></div>';
    root.appendChild(dlg);
    dlg.addEventListener('click', e => {
      if (e.target === dlg || e.target.closest('[data-c-sim-close]')) dlg.close();
    });
    dlg.addEventListener('close', () => {
      if (window.MQ && window.MQ.SIM) window.MQ.SIM.stop();
      document.documentElement.classList.remove('c-lock');
    });
  }

  function load() {
    if (loaded) return;
    loaded = true;
    fetch(location.pathname + '?section_id=lsl-sim-popup', { credentials: 'same-origin' })
      .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const pop = tmp.querySelector('.c-simpop');
        if (!pop) throw new Error('empty');
        dlg.querySelector('.c-simdlg__slot').replaceChildren(pop);
        if (!window.MQ && coreSrc) {
          const s = document.createElement('script');
          s.src = coreSrc;
          document.body.appendChild(s);
        }
      })
      .catch(() => {
        loaded = false;
        dlg.querySelector('.c-simdlg__slot').innerHTML = '<p class="c-simdlg__wait">Le simulateur n’a pas pu se charger. <a href="/#simulateur-accueil">L’ouvrir sur l’accueil</a></p>';
      });
  }

  document.addEventListener('click', e => {
    const a = e.target.closest('.c-guide__btn, [data-c-sim-open]');
    if (!a || !root.contains(a)) return;
    const href = a.getAttribute('href') || '';
    if (a.tagName === 'A' && href && !/simulateur/.test(href)) return;
    e.preventDefault();
    if (!dlg) build();
    document.documentElement.classList.add('c-lock');
    if (!dlg.open) dlg.showModal();
    load();
  });
})();
